import { Product } from "store/product/ProductTypes";

export const FETCH_PRODUCT_ALERTS_LIST = {
  REQUEST: "FETCH_PRODUCT_ALERTS_LIST_REQUEST",
  SUCCESS: "FETCH_PRODUCT_ALERTS_LIST_SUCCESS",
  FAILURE: "FETCH_PRODUCT_ALERTS_LIST_FAILURE",
};

export const FETCH_PRODUCTS_DETAILS = {
  REQUEST: "FETCH_PRODUCTS_DETAILS_REQUEST",
  SUCCESS: "FETCH_PRODUCTS_DETAILS_SUCCESS",
  FAILURE: "FETCH_PRODUCTS_DETAILS_FAILURE",
};

export interface SKU {
  storeId: string;
  productId: string;
  SKU: string;
  status: string;
  currentStock: Number;
  previousStock: Number;
  productName?: string;
}

export interface productAlertsList {
  accountId: string;
  watcher: string;
  jobStartTime: string;
  SKUs: SKU[];
}

export interface loadProductAlertsListAction {
  type: typeof FETCH_PRODUCT_ALERTS_LIST.REQUEST;
}

export interface loadProductAlertsListPayload {
  payload: productAlertsListPayload;
  type: typeof FETCH_PRODUCT_ALERTS_LIST;
}

export interface productAlertsListPayload {
  results: productAlertsList[];
}

export interface productDetails {
  productId: string;
  cachedProduct: Product;
}

export enum ProductStatus {
  "OOS-C" = "Out of stock",
  "OOS-1" = "Out of stock",
  LIS = "Low in stock",
  BIS = "Back in stock",
}
